import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserPhoto, UserPhotoHtmlElementId, UtilityService} from '@app/shared';

/**
 * @author Jin Chun (Aug 2018)
 * @desc common HR component to load/update user's photo. used by Profile, Customer/Consultant/Contractor/Employee data management
 */

@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.css']
})
export class PhotoComponent implements OnInit {

  @Input() photo: UserPhoto;
  @Output() handler: EventEmitter<boolean> = new EventEmitter();  // emit true when user's photo is updated

  maxFileSize = 250000;   // limit the size of the photo to be 250KB

  constructor(private utilityService: UtilityService) {
  }

  ngOnInit() {
    if (this.photo && this.photo.data) {
      this.showPhoto(this.photo);
    }
  }

  /**
   * @desc displays the user's photo with the html element id = UserPhotoHtmlElementId
   * @param photo to display
   */
  showPhoto(photo: UserPhoto): void {
    let photoImg = document.getElementById(UserPhotoHtmlElementId) as HTMLImageElement;
    photoImg.src = this.utilityService.buildHtmlImageSrc(photo.contentType, photo.data);
  }

  /**
   * @desc gets called when the user photo is selected from the local directory. This replaces the user photo data with the newly selected image.
   * @param event contains a list of files to upload
   * @param photo contentType is updated when the selected file is loaded
   */
  onPhotoUpload(event, photo: UserPhoto) {
    let photoImg = document.getElementById(UserPhotoHtmlElementId) as HTMLImageElement;
    if (photoImg) {
      let reader = new FileReader();
      photo.contentType = event.files[0].type;

      reader.addEventListener("load", function () {
        photoImg.src = reader.result as string;
      }, false);

      this.handler.emit(true);
      if (event.files[0]) {
        reader.readAsDataURL(event.files[0]);
      }
    }
  }
}
